module.exports = __webpack_public_path__ + "media/images/icons/green-check-00d34b014a16d56f4999b3f802b57cca.svg";